import { useEffect } from 'react';
import ReactGa from 'react-ga4';
import { useTranslation } from 'react-i18next';

import AuthPageShell from '@/components/auth/AuthPageShell';
import ClientOnboard from '@/components/client/ClientOnboard';
import RecruiterTerms from '@/components/recruiter/RecruiterTerms';
import { useCurrentUser } from '@/hooks/useCurrentUser';

const Terms = () => {
  const { user, isClient, isRecruiter } = useCurrentUser();
  const [t] = useTranslation();
  useEffect(() => {
    ReactGa.send('pageview');
  }, []);
  return (
    <AuthPageShell bannerTitle={t('GET_STARTED_LABEL')} bannerClickable={false}>
      {isClient && user?.company && (
        <ClientOnboard user={{ ...user, company: user.company }} />
      )}
      {isRecruiter && user && <RecruiterTerms user={user} isOnboard={true} />}
    </AuthPageShell>
  );
};

export default Terms;
